import type { Wrex } from '@lumapps/wrex/types';

import { isOrderedList } from './isOrderedList';
import { isUnorderedList } from './isUnorderedList';

export const isList = (node: any): node is Wrex.Element => isUnorderedList(node) || isOrderedList(node);
